import React, { useEffect, useState } from "react";
import Header from "../components/Header";

import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Footer from "../components/Footer";
import AlertSuccess from "../components/AlertSuccess";
import AlertError from "../components/AlertError";
import Loading from "../components/Loading";
import { FormatToBrl } from "../../utils/FormatToBrl";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import StepOne from "./components/steps/StepOne";
import StepTwo from "./components/steps/StepTwo";
import StepThree from "./components/steps/StepThree";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Typography } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const steps = [
    { number: 1, label: "Informações Pessoais" },
    { number: 2, label: "Confirmar E-mail" },
    { number: 3, label: "Definir Senha" },
    { number: 4, label: "Checkout" },
];

const introSteps = [
    { number: "01", text: "Informe seus dados e confirme seu e-mail.", color: "#ffc845", textColor: "#0b243d" },
    { number: "02", text: "Defina sua senha e escolha a forma de pagamento.", color: "#8CD790", textColor: "#0b243d" },
    { number: "03", text: "Pronto! Sua contabilidade na palma da mão.", color: "#0b243d", textColor: "white" },
];


const Register = () => {
    const navigate = useNavigate();


    const [isMobile, setIsMobile] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);

    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [leadId, setLeadId] = useState(null);

    const [loading, setLoading] = useState(false);

    const token = localStorage.getItem("token");


    const [nome, setNome] = useState("");
    const [telefone, setTelefone] = useState("");
    const [cpf, setCpf] = useState("");
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [confirmarSenha, setConfirmarSenha] = useState("");
    const [codigo, setCodigo] = useState("");
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [agreeContract, setAgreeContract] = useState(false);

    const [codigoEnviado, setCodigoEnviado] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Detectar se é mobile (tela menor que 768px)
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize(); // chama ao carregar
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSendCode = async () => {
        try {
            setCodigo("");
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/enviarEmail`, {
                email: email.trim().toLowerCase()
            });
            console.log(response.data);
            setCodigoEnviado(true);
            setMensagem(response.data.message || "Código enviado com sucesso para o seu e-mail.");
            setOpenSnackbarSuccess(true);
        } catch (error) {
            console.error(error);
            const status = error.response?.status;
            const mensagemBackend = error.response?.data?.erro || error.response?.data?.message;

            if (status === 400) {
                setMensagem(mensagemBackend || "Usuário já cadastrado.");
            } else if (status === 429) {
                setMensagem("Aguarde alguns segundos antes de solicitar um novo código.");
            } else {
                setMensagem(mensagemBackend || "Erro ao enviar o código. Tente novamente.");
            }
            setOpenSnackbarError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyCode = async () => {
        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/confirmarConta`, { email, codigo });
            console.log(response.data);
            return response.data.valido;
        } catch (error) {
            setMensagem("Erro ao verificar o código. Tente novamente.");
            setOpenSnackbarError(true);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const handleRegister = async () => {
        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/cadastro`, {
                nome,
                telefone,
                cpf,
                email,
                senha,
                agreeTerms,
                agreeContract,
            });
            console.log(response.data);
            return response.data.sucesso;
        } catch (error) {
            setMensagem("Erro ao registrar. Tente novamente.");
            setOpenSnackbarError(true);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const handleInitializeSection = async () => {
        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, { email, senha });
            localStorage.setItem("token", response.data.token);
            return response.data.token;
        } catch (error) {
            console.error("Erro ao inicializar a seção de checkout:", error);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const handleNextStep = async () => {
        let camposValidos = true;
        if (currentStep === 1) {
            if (!nome || !telefone || !cpf || !email) {
                setMensagem("Por favor, preencha todos os campos obrigatórios.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }
            // Validar CPF
            const cpfRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
            if (!cpfRegex.test(cpf)) {
                setMensagem("Por favor, insira um CPF válido.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }
            // Validar telefone
            const telefoneRegex = /^\(\d{2}\) \d \d{4}-\d{4}$/;
            if (!telefoneRegex.test(telefone)) {
                setMensagem("Por favor, insira um telefone válido.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }
            // Validar e-mail
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setMensagem("Por favor, insira um e-mail válido.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }

            await handleSendCode();

            if (!codigoEnviado) {
                setMensagem("Erro ao enviar o código de verificação. Tente novamente.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }
        }

        if (currentStep === 2) {
            if (!codigo) {
                setMensagem("Por favor, insira o código enviado para o seu e-mail.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }
            if (codigo.length !== 6) {
                setMensagem("O código deve ter 6 dígitos.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }

            const codigoValido = await handleVerifyCode();
            if (!codigoValido) {
                setMensagem("Código de verificação inválido.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }

        }

        if (currentStep === 3) {
            if (!senha || !confirmarSenha) {
                setMensagem("Por favor, preencha todos os campos de senha.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }
            if (senha !== confirmarSenha) {
                setMensagem("As senhas não coincidem.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }
            if (!agreeTerms) {
                setMensagem("Você deve concordar com os Termos de Uso.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }
            if (!agreeContract) {
                setMensagem("Você deve concordar com os termos do Contrato de Prestação de Serviços.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            }

            const registroSucesso = await handleRegister();
            if (!registroSucesso) {
                setMensagem("Erro ao registrar. Tente novamente.");
                setOpenSnackbarError(true);
                camposValidos = false;
                return;
            } else {
                const sucessoInicializacao = await handleInitializeSection();
                if (sucessoInicializacao) {
                    navigate("../checkout");
                } else {
                    setMensagem("Erro ao inicializar a seção. Tente novamente.");
                    setOpenSnackbarError(true);
                    camposValidos = false;
                    return;
                }
            }
        }

        if (!camposValidos) {
            return;
        }
        setCurrentStep((prev) => Math.min(prev + 1, 5));
    };

    const planoSelected = localStorage.getItem("planoSelecionado") ? JSON.parse(localStorage.getItem("planoSelecionado")) : false;

    return (
        <>
            <Header />
            <div style={{
                marginTop: "80px",
                width: "100%",
                padding: "20px",
                minHeight: "100vh",
                boxSizing: "border-box"
            }}>
                <div style={{
                    width: isMobile ? "100%" : "80%",
                    margin: "0 auto",
                    padding: isMobile ? "10px" : "20px",
                    // backgroundColor: "#f0f0f0",
                    borderRadius: "12px"
                }}>
                    <div style={{ padding: isMobile ? "6px 4px 16px" : "4px 4px 20px" }}>
                        <h1 style={{ margin: 0, fontSize: isMobile ? "1.5rem" : "2rem", color: "#0b243d", fontWeight: 700, lineHeight: 1.25 }}>
                            Que bom que você escolheu a Clarea Vital!
                        </h1>
                        <p style={{ margin: "8px 0 0", fontSize: isMobile ? "0.9rem" : "1rem", color: "#555", lineHeight: 1.5 }}>
                            Falta pouco para você ter uma contabilidade feita para profissionais da saúde. Confira os próximos passos.
                        </p>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: isMobile ? "4px" : "12px",
                            marginBottom: "24px",
                        }}
                    >
                        {introSteps.map((item, index) => (
                            <React.Fragment key={item.number}>
                                <div
                                    style={{
                                        position: "relative",
                                        overflow: "hidden",
                                        flex: isMobile ? "none" : 1,
                                        width: isMobile ? "100%" : "auto",
                                        maxWidth: isMobile ? "none" : "320px",
                                        minHeight: isMobile ? "auto" : "140px",
                                        boxSizing: "border-box",
                                        padding: isMobile ? "16px" : "24px",
                                        backgroundColor: "white",
                                        border: `2px solid ${item.color}`,
                                        borderRadius: "12px",
                                        display: "flex",
                                        flexDirection: isMobile ? "row" : "column",
                                        alignItems: isMobile ? "center" : "flex-start",
                                        gap: isMobile ? "14px" : "18px",
                                    }}
                                >
                                    {/* Anel decorativo */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: isMobile ? "-45px" : "-60px",
                                            right: isMobile ? "-45px" : "-60px",
                                            width: isMobile ? "90px" : "140px",
                                            height: isMobile ? "90px" : "140px",
                                            borderRadius: "50%",
                                            border: `${isMobile ? 18 : 28}px solid ${item.color}`,
                                            opacity: 0.35,
                                            pointerEvents: "none",
                                        }}
                                    />

                                    <span
                                        style={{
                                            position: "relative",
                                            flexShrink: 0,
                                            padding: "5px 9px",
                                            borderRadius: "6px",
                                            backgroundColor: item.color,
                                            color: item.textColor,
                                            fontSize: "0.85rem",
                                            fontWeight: 700,
                                        }}
                                    >
                                        {item.number}
                                    </span>
                                    <p
                                        style={{
                                            position: "relative",
                                            margin: 0,
                                            maxWidth: isMobile ? "80%" : "75%",
                                            fontSize: "0.95rem",
                                            color: "#0b243d",
                                            lineHeight: 1.4,
                                        }}
                                    >
                                        {item.text}
                                    </p>
                                </div>

                                {index < introSteps.length - 1 && (
                                    <ChevronRightIcon
                                        sx={{
                                            flexShrink: 0,
                                            color: introSteps[index + 1].color,
                                            fontSize: 28,
                                            transform: isMobile ? "rotate(90deg)" : "none",
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    {planoSelected && (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: isMobile ? "column" : "row",
                                alignItems: isMobile ? "stretch" : "center",
                                justifyContent: "space-between",
                                gap: isMobile ? "14px" : "24px",
                                backgroundColor: "#f9f9f9",
                                border: "1px solid #e0e0e0",
                                borderLeft: "5px solid #ffc845",
                                borderRadius: "12px",
                                padding: isMobile ? "16px" : "20px 24px",
                                marginBottom: "20px",
                                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                            }}
                        >
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ margin: 0, fontSize: "0.75rem", color: "#8a97a5", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                    Plano selecionado
                                </p>
                                <p style={{ margin: "4px 0 0", fontSize: isMobile ? "1.15rem" : "1.3rem", fontWeight: 700, color: "#0b243d" }}>
                                    {planoSelected.title || "Nenhum plano selecionado"}
                                </p>
                                <p style={{ margin: "6px 0 0", fontSize: isMobile ? "0.9rem" : "0.95rem", color: "#555", lineHeight: 1.5 }}>
                                    {planoSelected.description || "Nenhuma descrição disponível"}
                                </p>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: isMobile ? "row" : "column",
                                    alignItems: isMobile ? "center" : "flex-end",
                                    justifyContent: isMobile ? "space-between" : "center",
                                    gap: "6px",
                                    flexShrink: 0,
                                    paddingTop: isMobile ? "14px" : 0,
                                    borderTop: isMobile ? "1px solid #e0e0e0" : "none",
                                }}
                            >
                                <p style={{ margin: 0, color: "#0b243d", whiteSpace: "nowrap" }}>
                                    <span style={{ fontSize: isMobile ? "1.3rem" : "1.6rem", fontWeight: 700 }}>
                                        {FormatToBrl(planoSelected.price) || "Nenhum valor disponível"}
                                    </span>
                                    <span style={{ fontSize: "0.9rem", color: "#555" }}>/mês</span>
                                </p>
                                {planoSelected.periodicity && (
                                    <span
                                        style={{
                                            padding: "3px 10px",
                                            borderRadius: "999px",
                                            backgroundColor: "rgba(255, 200, 69, 0.25)",
                                            color: "#0b243d",
                                            fontSize: "0.8rem",
                                            fontWeight: 600,
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        Plano {planoSelected.periodicity}
                                    </span>
                                )}
                            </div>
                        </div>
                    )}
                    <div
                        style={{
                            backgroundColor: "#f9f9f9",
                            border: "1px solid #e0e0e0",
                            borderRadius: "12px",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                            padding: isMobile ? "16px 12px" : "24px 20px",
                            marginBottom: isMobile ? "16px" : "24px",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
                            {steps.map((step, index) => {
                                const isActive = step.number === currentStep;
                                const isCompleted = step.number < currentStep;
                                const isLast = index === steps.length - 1;
                                const circleSize = isMobile ? 32 : 44;
                                const columnWidth = isMobile ? circleSize : 130;
                                // Faz a linha encostar no círculo, avançando sobre o espaço vazio da coluna do label
                                const connectorOffset = (columnWidth - circleSize) / 2 - 8;

                                return (
                                    <React.Fragment key={step.number}>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                width: `${columnWidth}px`,
                                                flexShrink: 0,
                                                position: "relative",
                                                zIndex: 1,
                                            }}
                                        >
                                            {/* Círculo do número */}
                                            <div
                                                style={{
                                                    width: `${circleSize}px`,
                                                    height: `${circleSize}px`,
                                                    borderRadius: "50%",
                                                    boxSizing: "border-box",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    fontWeight: 700,
                                                    fontSize: isMobile ? "0.9rem" : "1.05rem",
                                                    backgroundColor: isActive ? "#ffc845" : isCompleted ? "#0b243d" : "white",
                                                    color: isActive ? "#0b243d" : isCompleted ? "white" : "#8a97a5",
                                                    border: isActive || isCompleted ? "none" : "2px solid #d0d6dd",
                                                    boxShadow: isActive ? "0 0 0 5px rgba(255, 200, 69, 0.3)" : "none",
                                                    transition: "all 0.3s ease",
                                                }}
                                            >
                                                {isCompleted
                                                    ? <CheckIcon sx={{ fontSize: isMobile ? 18 : 22 }} />
                                                    : step.number}
                                            </div>

                                            {/* Label (no mobile só o passo atual é exibido, abaixo) */}
                                            {!isMobile && (
                                                <p
                                                    style={{
                                                        margin: "10px 0 0",
                                                        textAlign: "center",
                                                        fontSize: "0.9rem",
                                                        lineHeight: 1.3,
                                                        color: isActive || isCompleted ? "#0b243d" : "#8a97a5",
                                                        fontWeight: isActive ? 700 : 500,
                                                        transition: "color 0.3s ease",
                                                    }}
                                                >
                                                    {step.label}
                                                </p>
                                            )}
                                        </div>

                                        {/* Linha de conexão */}
                                        {!isLast && (
                                            <div
                                                style={{
                                                    flex: 1,
                                                    height: "3px",
                                                    marginTop: `${circleSize / 2 - 1.5}px`,
                                                    marginLeft: `-${connectorOffset}px`,
                                                    marginRight: `-${connectorOffset}px`,
                                                    borderRadius: "3px",
                                                    backgroundColor: "#d0d6dd",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        height: "100%",
                                                        width: isCompleted ? "100%" : "0%",
                                                        backgroundColor: "#0b243d",
                                                        transition: "width 0.4s ease",
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>

                        {isMobile && (
                            <div style={{ marginTop: "14px", textAlign: "center" }}>
                                <p style={{ margin: 0, fontSize: "0.75rem", color: "#8a97a5", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                                    Passo {currentStep} de {steps.length}
                                </p>
                                <p style={{ margin: "2px 0 0", fontSize: "1rem", color: "#0b243d", fontWeight: 700 }}>
                                    {steps.find((step) => step.number === currentStep)?.label}
                                </p>
                            </div>
                        )}
                    </div>

                    <div style={{
                        width: "100%",
                        boxSizing: "border-box",
                        marginTop: "20px",
                        backgroundColor: "#f9f9f9",
                        border: "1px solid #e0e0e0",
                        borderRadius: "12px",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        overflow: "hidden",
                    }}>
                        {/* Cabeçalho do passo atual */}
                        <div style={{
                            padding: isMobile ? "16px 16px 0" : "24px 28px 0",
                        }}>
                            <h2 style={{ margin: 0, fontSize: isMobile ? "1.15rem" : "1.35rem", color: "#0b243d", fontWeight: 700 }}>
                                {steps.find((step) => step.number === currentStep)?.label}
                            </h2>
                        </div>

                        {/* Conteúdo do passo */}
                        <div style={{ padding: isMobile ? "8px 16px 20px" : "8px 28px 28px" }}>
                            {currentStep === 1
                                ? <StepOne
                                    nome={nome}
                                    setNome={setNome}
                                    telefone={telefone}
                                    setTelefone={setTelefone}
                                    cpf={cpf}
                                    setCpf={setCpf}
                                    email={email}
                                    setEmail={setEmail}
                                />
                                : currentStep === 2
                                    ? <StepTwo
                                        codigo={codigo}
                                        setCodigo={setCodigo}
                                        email={email}
                                        handleSendCode={handleSendCode}
                                    />
                                    : currentStep === 3
                                        ? <StepThree
                                            senha={senha}
                                            setSenha={setSenha}
                                            confirmarSenha={confirmarSenha}
                                            setConfirmarSenha={setConfirmarSenha}
                                            agreeTerms={agreeTerms}
                                            setAgreeTerms={setAgreeTerms}
                                            agreeContract={agreeContract}
                                            setAgreeContract={setAgreeContract}
                                        />
                                        : null
                            }
                        </div>

                        {/* Navegação */}
                        <div style={{
                            display: "flex",
                            flexDirection: isMobile ? "column-reverse" : "row",
                            justifyContent: currentStep === 1 ? "flex-end" : "space-between",
                            alignItems: isMobile ? "stretch" : "center",
                            gap: "12px",
                            padding: isMobile ? "16px" : "18px 28px",
                            borderTop: "1px solid #e0e0e0",
                            backgroundColor: "white",
                        }}>
                            {currentStep > 1 && (
                                <Button
                                    onClick={() => setCurrentStep((prev) => Math.max(prev - 1, 1))}
                                    variant="outlined"
                                    startIcon={<ArrowBackIcon />}
                                    sx={{
                                        padding: "8px 24px",
                                        fontSize: "0.95rem",
                                        fontWeight: 600,
                                        textTransform: "none",
                                        color: "#0b243d",
                                        borderColor: "#0b243d",
                                        borderRadius: "10px",
                                        transition: "0.3s ease",
                                        '&:hover': {
                                            borderColor: "#0b243d",
                                            backgroundColor: "rgba(11, 36, 61, 0.06)",
                                        },
                                    }}
                                >
                                    Voltar
                                </Button>
                            )}
                            <Button
                                onClick={handleNextStep}
                                variant="contained"
                                endIcon={<ArrowForwardIcon />}
                                sx={{
                                    padding: "8px 28px",
                                    fontSize: "0.95rem",
                                    fontWeight: 700,
                                    textTransform: "none",
                                    backgroundColor: "#ffc845",
                                    color: "#0b243d",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 10px rgba(255, 200, 69, 0.4)",
                                    transition: "0.3s ease",
                                    '&:hover': {
                                        backgroundColor: "#e9b53d",
                                        boxShadow: "0 6px 14px rgba(255, 200, 69, 0.5)",
                                    },
                                }}
                            >
                                {currentStep === 5 ? "Finalizar" : "Continuar"}
                            </Button>
                        </div>
                    </div>

                    {/* Ajuda via WhatsApp */}
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
                        <a
                            href={gerarLinkWhatsApp("Olá! Estou fazendo meu cadastro na Clarea Vital e tenho uma dúvida.")}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                width: isMobile ? "100%" : "auto",
                                boxSizing: "border-box",
                                padding: "12px 20px",
                                backgroundColor: "white",
                                border: "1px solid #e0e0e0",
                                borderRadius: "12px",
                                boxShadow: "0 4px 8px rgba(0,0,0,0.06)",
                                textDecoration: "none",
                                transition: "0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = "#25D366";
                                e.currentTarget.style.boxShadow = "0 6px 14px rgba(37, 211, 102, 0.2)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = "#e0e0e0";
                                e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.06)";
                            }}
                        >
                            <div
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    flexShrink: 0,
                                    borderRadius: "50%",
                                    backgroundColor: "rgba(37, 211, 102, 0.12)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <WhatsAppIcon sx={{ color: "#25D366", fontSize: 24 }} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.3 }}>
                                    Tem alguma dúvida?
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#0b243d", fontWeight: 700, lineHeight: 1.3 }}>
                                    Fale com um consultor
                                </Typography>
                            </div>
                            <ArrowForwardIcon sx={{ color: "#0b243d", fontSize: 20, ml: "8px" }} />
                        </a>
                    </div>
                </div>
            </div>
            <Footer />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
            <Loading open={loading} />
        </>
    );
}

export default Register;
